import React from 'react'
import classnames from 'classnames'
import CopyableValue from '../CopyableValue'

export interface DisplayFieldProps {
  label: string
  children?: React.ReactNode
  /** Render value in a monospace font (IDs, account numbers, cuids). */
  mono?: boolean
  /** When set, show a copy-to-clipboard control for this value. */
  copyValue?: string
  className?: string
}

const isPlainText = (node: React.ReactNode): boolean =>
  typeof node === 'string' || typeof node === 'number'

export const DisplayField: React.FC<DisplayFieldProps> = (props) => {
  const { label, children, mono, copyValue, className } = props
  const canCopy = copyValue != null && copyValue !== ''

  return (
    <div className={classnames('flex flex-col', className)}>
      <div className="mb-1 font-medium color-base text-slate-700 dark:text-slate-400">{label}</div>
      <div className="min-w-0">
        {canCopy ? (
          <CopyableValue
            value={copyValue}
            label={label}
            valueClassName={classnames(mono && 'font-mono text-sm')}
            iconClassName="h-4 w-4"
          >
            {children}
          </CopyableValue>
        ) : isPlainText(children) ? (
          <span className={classnames('block truncate', mono && 'font-mono text-sm')}>{children}</span>
        ) : (
          <div className={classnames('min-w-0', mono && 'font-mono text-sm')}>{children}</div>
        )}
      </div>
    </div>
  )
}

export default DisplayField
